<script setup lang="ts">
import type { Product } from 'types/models/product'

interface Props {
  product: Product
}

const props = defineProps<Props>()

const storyblokStore = useStoryblokStore()
const { state: storyblok } = storeToRefs(storyblokStore)

const pdpEnhancedBlockData = computed (() => storyblok.value.pdpEnhancedBlocks.find(page => props.product.categories.includes(page.identifier)))
</script>

<template>
  <section v-if="pdpEnhancedBlockData">
    <div v-editable="pdpEnhancedBlockData">
      <div
        v-for="(component, index) in pdpEnhancedBlockData.body"
        :key="component._uid"
        data-test="pdp-enhanced"
      >
        <component
          :is="component.component"
          :key="component._uid"
          :blok="component"
          :data-position="index"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>

</style>
